<div class="confirm-send-heading">Detail</div>
<app-spo-detail [spoDetail]="headerStep.data"></app-spo-detail>
<app-material-list [materials]="filteredMaterialList.data" [showBtnAdd]="false" [showTooltipWarnings]="false"
                   data-cy="confirm-send-material-list">
</app-material-list>
